export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/youtube.0fdf8cc8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};